import React, { useState } from "react";
import {
    Box,
    Typography,
    TextField,
    Button,
    InputAdornment,
    IconButton,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";
import "../Signup/Signup.css"
import { DynamicToastContent } from '../Toast/CommonToast';
import { toast } from "react-toastify";
import messageLogo from "../../assets/Message.png";
import { resetPasswordRes } from "../../services/apiService";
import CheckIcon from '@mui/icons-material/Check';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Reset: React.FC = () => {
    const [formData, setFormData] = useState({
        password: "",
        confirmPassword: "",
        otp: ""
    });

    const [showPassword, setShowPassword] = useState(false);
    const [passwordStrength, setPasswordStrength] = useState("");
    const [formErrors, setFormErrors] = useState({
        fullName: "",
        email: "",
        password: "",
        confirmPassword: "",
        otp: ""
    });

    const navigate = useNavigate();
    // const desktop = window.innerWidth > 1440;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });

        if (name === "password") {
            if (
                value.length >= 8 &&
                /[0-9]/.test(value) &&
                /[a-z]/.test(value) &&
                /[!@#$%^&*]/.test(value)
            ) {
                setPasswordStrength("strong");
            } else if (value.length >= 8 && /[0-9]/.test(value)) {
                setPasswordStrength("medium");
            } else if (value.length >= 8) {
                setPasswordStrength("weak");
            } else {
                setPasswordStrength("");
            }
        }
    };

    const validateForm = () => {
        const errors = { ...formErrors };
        let isValid = true;



        // Validate password
        const regularExpression = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,15}$/;
        if (!formData.password) {
            errors.password = "Password is required";
            isValid = false;
        } else if (!regularExpression.test(formData.password)) {
            errors.password =
                "Password must be at least 8 characters, include a number, a symbol, and a lowercase letter.";
            isValid = false;
        } else {
            errors.password = "";
        }
        // Validate confirmPassword
        if (!formData.confirmPassword) {
            errors.confirmPassword = "Please confirm your password";
            isValid = false;
        } else if (formData.confirmPassword !== formData.password) {
            errors.confirmPassword = "Passwords do not match";
            isValid = false;
        } else {
            errors.confirmPassword = "";
        }


        setFormErrors(errors);
        return isValid;
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    
        if (validateForm()) {
            try {
                console.log("Form submitted successfully", formData);
    
                const response = await resetPasswordRes({
                    newPassword: formData.password,
                    otp: formData.otp
                });
    
                if (response.status === 'true') {
                    const toastContent = (
                        <DynamicToastContent
                            icon={messageLogo}
                            message={"Password has been reset successfully."}
                        />
                    );
                    toast(toastContent, {
                        closeOnClick: false,
                        pauseOnHover: false,
                        draggable: false,
                    });
                    navigate('/login')
                }
            } catch (error) {
                console.error("Error resetting password:", error);
                toast.error("Failed to reset password. Please try again later.");
            }
        }
    };
    
    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    return (
        <Box className="maincontainer">

            <Box className="imagecontainer">

{/* 
            <img
                    src={desktop ? 'https://showcasaai.blob.core.windows.net/applicationasset/1920_Image.svg':'https://showcasaai.blob.core.windows.net/applicationasset/1440_Image.svg'}
                    alt="Background"
                    style={{ width: "100%",objectFit: "cover", height: '100%' }}
                /> */}
            </Box>

            <Box className="leftcontainer">

                <Box sx={{ maxWidth: 350, width: "100%" }}>
                    <Box sx={{ textAlign: "left", marginBottom: 3 }}>
                        <img
                            src={'/assets/showcasaNew.svg'}
                            alt="Logo"
                            className="showcasalogo"
                        />
                        
                    </Box>
                     <Box display="flex" alignItems="center" gap={1} sx={{width: '100%'}}>
                    <ArrowBackIcon style={{ cursor: 'pointer' }} onClick={() => navigate('/forgot-password')} />
                    <Typography variant="body1" align="center" className='forgot-verify'>Reset password</Typography>
                </Box>

                    <form onSubmit={handleSubmit} className="form">
                        <TextField
                            label="OTP"
                            variant="outlined"
                            name="otp"
                            type="text"
                            value={formData.otp}
                            onChange={handleChange}
                            error={Boolean(formErrors.otp)}
                            helperText={formErrors.otp}
                            className="textField"
                            fullWidth
                            margin="normal"
                            sx={{
                                ".MuiOutlinedInput-root": {
                                    "& fieldset": { borderColor: "gray" },
                                    "&:hover fieldset": { borderColor: "darkgray" },
                                    "&.Mui-focused fieldset": { borderColor: "gray" },
                                },
                                ".MuiInputLabel-root": { color: "gray" },
                                ".MuiInputLabel-root.Mui-focused": { color: "gray" },
                                "input:-webkit-autofill": {
                                    WebkitBoxShadow: "0 0 0px 1000px #1b1b2f inset",
                                    WebkitTextFillColor: "#fff",
                                },
                                "input:-webkit-autofill:focus": {
                                    WebkitBoxShadow: "0 0 0px 1000px #1b1b2f inset",
                                    WebkitTextFillColor: "#fff",
                                },
                            }}
                        />

                        <TextField
                            label="Password"
                            variant="outlined"
                            name="password"
                            type={showPassword ? "text" : "password"}
                            value={formData.password}
                            onChange={handleChange}
                            error={Boolean(formErrors.password)}
                            helperText={formErrors.password}
                            className="textField"
                            fullWidth
                            margin="normal"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={togglePasswordVisibility}>
                                            {showPassword ? (
                                                <VisibilityOff className="VisibilityOff" />
                                            ) : (
                                                <Visibility className="Visibility" />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                            sx={{
                                ".MuiOutlinedInput-root": {
                                    "& fieldset": { borderColor: "gray" },
                                    "&:hover fieldset": { borderColor: "darkgray" },
                                    "&.Mui-focused fieldset": { borderColor: "gray" },
                                },
                                ".MuiInputLabel-root": { color: "gray" },
                                ".MuiInputLabel-root.Mui-focused": { color: "gray" },
                                "input:-webkit-autofill": {
                                    WebkitBoxShadow: "0 0 0px 1000px #1b1b2f inset",
                                    WebkitTextFillColor: "#fff",
                                },
                                "input:-webkit-autofill:focus": {
                                    WebkitBoxShadow: "0 0 0px 1000px #1b1b2f inset",
                                    WebkitTextFillColor: "#fff",
                                },
                            }}
                        />

                        <Box className="passwordStrength">
                            {[...Array(3)].map((_, index) => (
                                <Box
                                    key={index}
                                    className={`passwordBar ${passwordStrength === "strong"
                                        ? "strong"
                                        : passwordStrength === "medium" && index <= 1
                                            ? "medium"
                                            : passwordStrength === "weak" && index === 0
                                                ? "weak"
                                                : ""
                                        }`}
                                />
                            ))}
                        </Box>
                        <TextField
                            label="Confirm Password"
                            variant="outlined"
                            name='confirmPassword'
                            type={showPassword ? 'text' : 'password'}
                            fullWidth
                            sx={{
                                ".MuiOutlinedInput-root": {
                                    "& fieldset": { borderColor: "gray" },
                                    "&:hover fieldset": { borderColor: "darkgray" },
                                    "&.Mui-focused fieldset": { borderColor: "gray" },
                                },
                                ".MuiInputLabel-root": { color: "gray" },
                                ".MuiInputLabel-root.Mui-focused": { color: "gray" },
                                "input:-webkit-autofill": {
                                    WebkitBoxShadow: "0 0 0px 1000px #1b1b2f inset",
                                    WebkitTextFillColor: "#fff",
                                },
                                "input:-webkit-autofill:focus": {
                                    WebkitBoxShadow: "0 0 0px 1000px #1b1b2f inset",
                                    WebkitTextFillColor: "#fff",
                                },
                            }}
                            margin="normal"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="toggle confirm password visibility"
                                            edge="end"
                                        >
                                            {(formData.password && formData.confirmPassword && formData.password === formData.confirmPassword) ? (
                                                <CheckIcon style={{ color: '#fff' }} />
                                            ) : null}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />


                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            className="submitButton"
                            sx={{ marginTop: 2 }}
                        >
                            Submit
                        </Button>
                    </form>

                </Box>
            </Box>
        </Box>
    );
};

export default Reset;
